import { Component, OnInit, ViewEncapsulation, NgZone, Renderer2, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';

import { SelectItem, Message, MenuItem } from 'primeng/primeng';
import { HomeService } from './home.service';
import { NewReleaseService } from '../new-release/new-release.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';

import { Release } from './release';
import { MainService } from '../main.service';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';

import { ConfirmationService } from 'primeng/primeng';

import { MatDialog } from '@angular/material';

import { FileUploader } from 'ng2-file-upload';
import { ReleaseEditModelComponent } from '../shared/release-edit-model/release-edit-model.component';
import { SelectQAComponent } from '../shared/select-qa/select-qa.component';

// const URL = environment.uploadURL;
const URL = "/upload"
const DownloadURL = environment.downloadURL;


@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../style.scss',
    './home.component.css'
  ]
})


export class HomeComponent implements OnInit {
  releaseData: Release[];
  // fromDate: Date = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
  // toDate: Date = new Date();
  fromDate: Date = localStorage.getItem("fromDate") ? new Date(JSON.parse(localStorage.getItem("fromDate"))) : new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
  toDate: Date = localStorage.getItem("toDate") ? new Date(JSON.parse(localStorage.getItem("toDate"))) : new Date();
  formatFromDate;
  formatToDate;
  fdMonth;
  toMonth;
  options: {};
  userOptions: {};
  versionOptions: {};
  componentOptions: {};
  projectOptions: {}
  downloadOptions: {};
  editOptions: {};
  editEmailOptions: {};
  activityOptions: {};
  componentEditOptions: {};
  releaseEditDataOptions: {};
  changeWorkFlowOptions: {};
  discardOptions: {};
  releasecompOptions: {};
  updateQAOptions: {};
  projectData;
  editRelease: any;
  editReleaseNote: any;
  editTestCase: any;

  editReleaseLoc: any;
  editReleaseNoteLoc: any;
  editTestCaseLoc: any;

  // selectedProject: any;
  // selectedProj: any = [{"id":10009,"name":"DFN Intl - SICO","key":"SICO","_$visited":true},{"id":10009,"name":"DFN Intl - SICO","key":"SICO","_$visited":true}];
  selectedProject: any = JSON.parse(localStorage.getItem("savedProject"));
  selectedComponents: any;
  selectedRelease: any;
  projectList: any[];

  responce: any;
  activityResponce: any;

  selectedProjectLatest: any;
  projectListLatest: any[];

  selectedWorkflowLatest: any;
  selectedWorkflow: any;

  selectedComponent: any;
  componentList: any[];
  editComponentList: any[];
  versionList: any[];
  userList: any[];


  status: any;
  workFlowList: any;

  selectedComponentLatest: any = localStorage.getItem("component") ? localStorage.getItem("component") : '';
  selectedProjects: any;
  componentListLatest: any[];


  selectedEditReleaseOwner: any;
  selectedEditVersion: any;
  selectedEditWorkFlow: any;
  selectedEditComponent: any;
  selectedEditProject: any;
  selectedEditDescription: any;
  selectedEditComment: any;
  selectedEditQA: any;
  release_ID: any;
  cc_list: String;

  fileName: string;
  fileName_Note: string;
  fileName_Test: string;
  originalFileName: string;
  originalFileName_Note: string;
  originalFileName_Test: string;
  isUploaded: boolean = false;
  isSaved: boolean = false;
  isFileSelected: boolean = false;
  isNoteSelected: boolean = false;
  isTestCaseSelected: boolean = false;
  isComment: boolean = false;
  isMessage: boolean = false;
  fileMissing: boolean = false;

  projectName: string;
  componentName: string;
  wid: number;
  workflowMessage: string;
  sendCmt: string;

  _rid: any;
  _workflow: any;

  msgs: Message[];
  activeIndex: number;
  items: MenuItem[];

  loading: boolean;

  global: any;


  showEdit: boolean = false;

  workflows = ['Dev', 'QA', 'UAT', 'Prod'];

  date = new Date();
  userEmail = localStorage.getItem('userEmail');
  userName = localStorage.getItem('userName');
  is_Admin = localStorage.getItem('is_Admin');


  // session details
  sessionCreatedTime = localStorage.getItem('sessionCreatedTime');
  sessionTime = new Date(parseInt(this.sessionCreatedTime));
  // sessionCreatedTime = new Date(sessionTime.getTime() +1200000);
  sessionExpireTime = Number(new Date(this.sessionTime.getTime() + 14400000));


  lookupRowStyleClass(rowData: Release) {
    return (rowData.is_discarded || rowData.is_rejected) ? 'rowSelected' : '';
  }

  // session validation
  isValidSession() {
    if (this.date.getTime() >= this.sessionExpireTime) {
      this.authService.logout();
      this.router.navigate(['/Login']);
    }
  };


  onRowSelect(release: Release) {
    setTimeout(() => {
      this.router.navigate(['/release/' + release.id]);
    },
      500);

  }

  // discard release
  discardRelease(r: Release) {
    this.discardOptions = {
      id: r.id
    };

    this.homeService.discardRelease(this.discardOptions).then(discard => {
      this.responce = discard.status;
      this.msgs = [];
      this.msgs = [{ severity: 'success', summary: 'Discarded' }];

      setTimeout(() => {
        this.search();
      },
        500);


    });
  }

  // reject release
  rejectRelease(r: Release) {
    this.discardOptions = {
      id: r.id
    };

    this.homeService.rejectRelease(this.discardOptions).then(reject => {
      this.responce = reject.status;
      this.msgs = [];
      this.msgs = [{ severity: 'success', summary: 'Rejected' }];

      setTimeout(() => {
        this.search();
      },
        500);


    });
  }


  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }


  resetCompList() {
    this.selectedComponentLatest = '';
  }

  resetCompAuto() {
    this.selectedComponent = undefined;
    this.selectedComponentLatest = '';
    this.selectedComponents = '';
    this.search();
  }

  resetProjList() {
    this.selectedProjectLatest = undefined;
  }

  resetProjAuto() {
    localStorage.removeItem("savedProject");
    this.selectedProject = undefined;
    this.selectedProjects = '';
    this.selectedProjectLatest = undefined;
    this.search();
  }

  display: boolean = false;

  addComment() {
    if (this.workflowMessage == undefined) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Empty Comment' });
    } else if (this.workflowMessage.length < 20) {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Comment Too Short' });
    } else {
      var userCmt = this.workflowMessage;

      this.sendCmt = (userCmt.replace("<p>", "")).replace("</p>", "");

      this.sendWorkflowUpdate();

      this.workflowMessage = '';
      this.isMessage = false;
    }

  }

  changeWorkFlow(rd: Release) {

    this._rid = rd.id;
    this._workflow = rd.workflow_id;

    if (rd.workflow_id == 0 && (rd.qa == undefined || rd.owner == this.userName)) {
      var editStage: any[] = this.releaseData.filter(temp =>
        temp.workflow_id == rd.workflow_id)

      editStage[0].workflow_id += 1;

      this._workflow = editStage[0].workflow_id + 1;

      setTimeout(() => {
        if (rd.qa != undefined && (rd.qa == this.userName || rd.owner == this.userName || this.is_Admin == '1')) {
          this.sendWorkflowUpdate();
        } else {
          const dialogRef = this.dialog.open(SelectQAComponent, {
            width: '900px',
            data: rd,
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result == undefined) {
              this.search();
            } else {
              this.updateQA(result.data, result.qa);

            }

          });
        }
      },
        100);
    } else if (rd.qa != this.userName || rd.owner != this.userName || this.is_Admin == '1') {
      this.isMessage = true;
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Change Work Flow', detail: 'No Permission' });

    }
  }


  updateQA(data, qaData) {

    this.updateQAOptions = {
      release_id: data.id,
      qa: qaData.name
    };

    this.homeService.updateQA(this.updateQAOptions).then(workflow => {
      this.status = JSON.stringify(workflow.status);
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'QA Assigned' });
      setTimeout(() => {
        this.sendWorkflowUpdate();
        // setTimeout(() => {
        //   this.search();
        // },
        //   500);
      },
        500);


    });

    this.editEmailOptions = {
      fromEmail: this.userEmail,
      fromUser: this.userName,
      toEmail: qaData.email,
      toUser: qaData.name,
      subject: "Moved to QA - " + data.version,
      version: data.version,
      project: data.project,
      cc: data.cc_list ? data.cc_list : '',
      // cc: this.selectedEditReleaseOwner.email,
      component: data.component,
      desc: data.description,
      index: data.id
    };

    this.sendEditEmail();


  }

  sendWorkflowUpdate() {

    if (this.isMessage == true) {
      var editStage: any[] = this.releaseData.filter(temp =>
        temp.workflow_id == this._workflow)
      if (this._workflow < 4) {
        editStage[0].workflow_id += 1;
        this._workflow = editStage[0].workflow_id + 1;
      }
      this.sendCmt = "Moved to " + editStage[0].workflow;
    }

    this.changeWorkFlowOptions = {
      release_id: this._rid,
      workflow: this._workflow,
      comment: this.sendCmt,
      user: this.userEmail
    }

    this.mainService.sendEditWorkFlow(this.changeWorkFlowOptions).then(workflow => {
      this.status = JSON.stringify(workflow.status);
      this.msgs = [];
      this.msgs.push({ severity: 'success', summary: 'Stage Updated' });
      setTimeout(() => {
        this.search();
      },
        500);

    });

    this.activityOptions = {
      user: this.userEmail,
      action: "Change Work Flow",
      file: "--"
    };

    this.newReleaseService.sendActivity(this.activityOptions).then(res => {
      this.activityResponce = res;
    });

  }

  showEditDialog(r): void {

    if (r.owner == this.userName || r.uploaded_by == this.userName || r.qa == this.userName || this.is_Admin == '1') {
      const dialogRef = this.dialog.open(ReleaseEditModelComponent, {
        width: '900px',
        height: '600px',
        data: r
      });

      dialogRef.afterClosed().subscribe(result => {
        this.getReleaseData();
      });

    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Edit Release', detail: 'No Permission' });
    }

  }

  // show edit model
  showEditModel(r: Release) {
    this.selectedEditDescription = r.description;
    this.editRelease = r.file_name ? r.file_name : null;
    this.editReleaseNote = r.release_note ? r.release_note : null;
    this.editTestCase = r.test_cases ? r.test_cases : null;

    this.editReleaseLoc = r.storage_location ? r.storage_location : null;
    this.editReleaseNoteLoc = r.release_note_location ? r.release_note_location : null;
    this.editTestCaseLoc = r.test_case_location ? r.test_case_location : null;

    this.componentName = r.component;
    this.projectName = r.pkey;
    this.wid = 0;
    this.cc_list = r.cc_list;

    this.release_ID = r.id;

    this.wid = r.workflow_id;
    this.activeIndex = r.workflow_id - 1;

    // edit modal values
    for (var i = 0; i < this.projectList.length; i++) {
      if (this.projectList[i].name == r.project) {
        this.releaseUpdateForm.patchValue({
          project: this.projectList[i]
        }
        );
      }
    }

    for (var i = 0; i < this.workFlowList.length; i++) {
      if (this.workFlowList[i].workflow == r.workflow) {
        this.releaseUpdateForm.patchValue({
          workflow: this.workFlowList[i]
        }
        );

        this.activeIndex = this.workFlowList[i].id - 1;

      }
    }

    // patch email list to edit model
    var emailList = [];

    if (r.cc_list != null) {
      var emails = r.cc_list.split(",");
      for (let email of emails) {
        emailList.push(email);
      }
    }


    this.releaseUpdateForm.patchValue({
      emailList: emailList
    }
    );


    this.componentEditOptions = {
      id: r.project_id,
      list: ''
    };

    this.getEditComponents(r);

    this.userOptions = {
      id: r.project_id,
      role: ''
    };


    this.getEditUsers(r);

    this.versionOptions = {
      id: r.project_id,
      component: r.component,
      editMode: 'true'
    };

    this.getEditVersion(r);

  }


  releaseUpdateForm: FormGroup;

  // sync  release data
  sync() {
    this.global = null;

    this.search();
  }

  // reset release data
  resetMain() {
    this.selectedProjectLatest = undefined;
    this.selectedComponentLatest = '';
    this.selectedProjects = '';
    this.selectedComponents = '';
    this.selectedWorkflowLatest = '';

    this.fromDate = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
    this.toDate = new Date();

    if (this.global != null) {
      this.global = null;
      this.search();
    } else {
      this.global = null;
    }
  }

  projectFilter() {

    if (this.selectedProject != undefined) {
      this.selectedProjects = '';
      // var savedProject = [];
      var savedProject = [];
      // if(localStorage.getItem("savedProject") != null){
      //   savedProject.push(JSON.parse(localStorage.getItem("savedProject")));
      // }

      if (this.selectedProject.length == 0) {
        localStorage.removeItem("savedProject");
      } else {
        for (var i = 0; i < this.selectedProject.length; i++) {
          if (i == 0) {
            this.selectedProjects = this.selectedProject[i].id;
            savedProject.push(this.selectedProject[i]);
            localStorage.setItem("savedProject", JSON.stringify(savedProject));

          } else {
            this.selectedProjects = this.selectedProjects + ',' + this.selectedProject[i].id;
            savedProject.push(this.selectedProject[i]);
            localStorage.setItem("savedProject", JSON.stringify(savedProject));
          }
        }
      }

    }

    this.search();
  }

  search() {

    var savedProject = [];

    localStorage.setItem('sessionExpireTime', String(this.sessionExpireTime));

    if (this.selectedProjectLatest == '') {
      this.selectedProjectLatest = undefined;
    }

    if (this.selectedProjectLatest != undefined) {
      this.selectedProject = undefined;
      this.selectedProjects = undefined;
    } else {
      if (localStorage.getItem("savedProject") != null) {
        this.selectedProject = JSON.parse(localStorage.getItem("savedProject"));
      }
    }

    if (this.selectedComponentLatest != '') {
      this.selectedComponent = undefined;
      this.selectedComponents = undefined;
    }

    if (this.selectedComponent != undefined) {
      this.selectedComponents = '';
      for (var i = 0; i < this.selectedComponent.length; i++) {
        if (i == 0) {
          this.selectedComponents = this.selectedComponent[i].component;
        } else {
          this.selectedComponents = this.selectedComponents + ',' + this.selectedComponent[i].component;
        }
      }
    }


    if (this.selectedProject != undefined) {
      this.selectedProjects = '';
      var savedProject = [];
      if (localStorage.getItem("savedProject") != null) {
        savedProject.push(JSON.parse(localStorage.getItem("savedProject")));
      }

      for (var i = 0; i < this.selectedProject.length; i++) {
        if (i == 0) {
          this.selectedProjects = this.selectedProject[i].id;
        } else {
          this.selectedProjects = this.selectedProjects + ',' + this.selectedProject[i].id;

        }
      }
    }

    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();


    localStorage.setItem("fromDate", JSON.stringify(this.fromDate));
    localStorage.setItem("toDate", JSON.stringify(this.toDate));

    // if All Option selected getting all release details
    if (this.selectedWorkflowLatest != undefined) {
      if (this.selectedWorkflowLatest.workflow == 'All') {
        this.selectedWorkflow = '';
      } else {
        this.selectedWorkflow = this.selectedWorkflowLatest;
      }
    }

    localStorage.setItem("component", this.selectedComponentLatest);

    this.options = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: this.selectedProjectLatest ? this.selectedProjectLatest : '',
      c: this.selectedComponentLatest ? this.selectedComponentLatest : '',
      pList: this.selectedProjects ? this.selectedProjects : '',
      cList: this.selectedComponents ? this.selectedComponents : '',
      workflow: this.selectedWorkflow ? this.selectedWorkflow.workflow : '',
      release_id: this.selectedRelease ? this.selectedRelease.id : '',
      user: this.userEmail ? this.userEmail : ''
    };

    this.getReleaseData();

    this.releasecompOptions = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      user: this.userEmail
    };

    this.getReleaseComponents();

  }

  // project search 
  projectEventHandler(event) {
    if (event.keyCode == 13) {
      this.searchByProject();
    }
  }


  getWorkflow() {
    this.mainService.getWorkflow(this.options).then(workflow => {
      this.workFlowList = workflow;

      this.items = [];
      for (var i = 0; i < this.workFlowList.length; i++) {

        if (i != 0) {
          var obj = { label: this.workFlowList[i].workflow };
          this.items.push(obj);

        }

      }
    });
  }

  searchByProject() {

    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();

    if (this.selectedProject == undefined) {
      this.fdMonth = (this.fromDate.getMonth() + 1);
      this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();
    } else {
      this.formatFromDate = "01/07/2017";
    }

    this.options = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: this.selectedProject ? this.selectedProject.name : "",
      c: "",
    };

    this.getReleaseData();

  }

  // component search 
  componentEventHandler(event) {
    if (event.keyCode == 13) {
      this.searchByComponent();
    }
  }

  // release search 
  searchEventHandler(event) {
    if (event.keyCode == 13) {
      this.search();
    }
  }

  // work flow filter
  workFlowFilter() {
    if (this.selectedWorkflowLatest.workflow != undefined) {
      this.search();
    }

  }

  searchByComponent() {

    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();

    if (this.selectedComponent == undefined) {
      this.fdMonth = (this.fromDate.getMonth() + 1);
      this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();
    } else {
      this.formatFromDate = "01/07/2017";
    }

    this.options = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: "",
      c: this.selectedComponent ? this.selectedComponent.component : "",
    };

    this.getReleaseData();

  }

  // download release 
  sendLocation(s: Release) {
    this.downloadOptions = {
      locaction: s.storage_location
    };

    this.options = {
      user: this.userEmail,
      action: "Download Release",
      file: s.file_name
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  // download release note
  sendNoteLocation(s: Release) {
    this.downloadOptions = {
      locaction: s.release_note_location
    };

    this.options = {
      user: this.userEmail,
      action: "Download Release Note",
      file: s.release_note
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });


    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  // download Test Case
  sendTestCasesLocation(s: Release) {

    this.downloadOptions = {
      locaction: s.test_case_location
    };

    this.options = {
      user: this.userEmail,
      action: "Download Test Case",
      file: s.test_cases
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  getDownload() {

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Downloading.....' });
    setTimeout(() => {
      window.location.href = DownloadURL;
    },
      1000);

  }

  getProjects() {
    var that = this;
    this.projectOptions = {
      user: this.userEmail
    };
    this.mainService.getProjectList(this.projectOptions).then(projects => {
      that.projectList = projects;
    });


  }

  getReleaseComponents() {

    this.releasecompOptions = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      user: this.userEmail
    };

    this.homeService.getReleaseComponents(this.releasecompOptions).then(components => {
      this.componentList = components;
    });


  }

  getComponents() {

    this.componentOptions = {
      id: '',
      list: '',
      user: this.userEmail
    };


    this.mainService.getComponents(this.componentOptions).then(components => {
      this.componentList = components;
    });
  }

  getEditComponents(release) {

    this.mainService.getComponents(this.componentEditOptions).then(components => {
      this.editComponentList = components;

      for (var i = 0; i < this.editComponentList.length; i++) {
        if (this.editComponentList[i].component == release.component) {
          this.releaseUpdateForm.patchValue({
            component: this.editComponentList[i]
          }
          );
        }
      }


    });

  }


  removeFile() {
    this.editRelease = true;
    this.editReleaseNote = true;
  }

  getVersion() {
    this.mainService.getVersions(this.versionOptions).then(versions => {
      this.versionList = versions;
    });
  }

  getEditVersion(release) {


    this.mainService.getVersions(this.versionOptions).then(versions => {
      this.versionList = versions;

      for (var i = 0; i < this.versionList.length; i++) {
        if (this.versionList[i].version == release.version) {
          this.releaseUpdateForm.patchValue({
            version: this.versionList[i]
          }
          );
        }
      }

    });
  }

  getUsers() {

    this.mainService.getUsers(this.userOptions).then(users => {
      this.userList = users;
    });

  }

  getEditUsers(release) {
    this.mainService.getUsers(this.userOptions).then(users => {
      this.userList = users;

      //qa 
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].name == release.qa) {
          this.releaseUpdateForm.patchValue({
            qa: this.userList[i]
          }
          );
        }
      }

      //owner
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].name == release.owner) {
          this.releaseUpdateForm.patchValue({
            owner: this.userList[i]
          }
          );
        }
      }

    });
  }

  getReleaseData() {
    this.releaseData = [];
    this.loading = true;
    // console.log("userEmail", this.userEmail);
    // console.log("useroptoins",this.options);
    this.homeService.getReleaseData(this.options).then(release => {
      if (release.length != undefined) {
        // console.log("user", this.userEmail);
        // console.log("user",this.options);
        this.releaseData = release;
        this.loading = false;
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  update() {

    if ((this.editRelease == null && this.isFileSelected == true)) {
      this.msgs = [];
      this.fileMissing = false;
      this.msgs.push({ severity: 'warn', summary: 'Release File Not Uploaded', detail: '' });
    }
    else if (this.isFileSelected == true) {
      this.msgs = [];
      this.fileMissing = false;
      this.msgs.push({ severity: 'error', summary: 'File Not Uploaded', detail: '' });
    }
    else if ((this.editRelease == null && this.fileName == undefined)) {
      this.msgs = [];
      this.fileMissing = false;
      this.msgs.push({ severity: 'error', summary: 'Release is Missing', detail: '' });
    } else {

      if (this.releaseUpdateForm.valid || this.isComment == false) {
        var sendDesc = this.stripHTML(this.stripHTML(this.selectedEditDescription));

        this.componentName = this.selectedEditComponent.component;
        this.projectName = this.selectedEditProject.key;

        this.editOptions = {
          release_id: this.release_ID,
          project: this.selectedEditProject.id,
          component: this.selectedEditComponent.id,
          version: this.selectedEditVersion.version,
          desc: sendDesc,
          fileName: this.editRelease ? this.editRelease : this.fileName,
          owner: this.selectedEditReleaseOwner.id,
          destination: this.editReleaseLoc ? this.editReleaseLoc : '../Uploads/Binary/' + this.projectName + '/' + this.componentName + '/' + this.fileName + '/' + this.originalFileName,
          note: this.editReleaseNote ? this.editReleaseNote : this.fileName_Note,
          relaseNote: this.editReleaseNoteLoc ? this.editReleaseNoteLoc : this.originalFileName_Note ? '../Uploads/Release_Notes/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Note + '/' + this.originalFileName_Note : '',
          test: this.editTestCase ? this.editTestCase : this.fileName_Test,
          testCases: this.editTestCaseLoc ? this.editTestCaseLoc : this.originalFileName_Test ? '../Uploads/Test_Cases/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Test + '/' + this.originalFileName_Test : '',
          updated_by: this.userName,
          workflow: this.selectedEditWorkFlow.id,
          qa: this.selectedEditQA ? this.selectedEditQA.name : '',
          cc: this.releaseUpdateForm.get('emailList').value ? this.releaseUpdateForm.get('emailList').value : this.selectedEditReleaseOwner.email,
        };

        this.editEmailOptions = {
          fromEmail: this.userEmail,
          fromUser: this.userName,
          toEmail: this.selectedEditQA ? this.selectedEditQA.email : '',
          toUser: this.selectedEditQA ? this.selectedEditQA.name : '',
          subject: "Updated - " + this.selectedEditVersion.version,
          version: this.selectedEditVersion.version,
          project: this.selectedEditProject.name,
          cc: this.releaseUpdateForm.get('emailList').value ? this.releaseUpdateForm.get('emailList').value : this.selectedEditReleaseOwner.email,
          // cc: this.selectedEditReleaseOwner.email,
          component: this.selectedEditComponent.component,
          desc: sendDesc,
          index: this.release_ID
        };




        if (this.isComment) {
          var userCmt = this.selectedEditComment;

          this.sendCmt = (userCmt.replace("<p>", "")).replace("</p>", "");

          this.changeWorkFlowOptions = {
            release_id: this.release_ID,
            workflow: this.selectedEditWorkFlow.id,
            comment: this.sendCmt,
            user: this.userEmail
          }

          this.mainService.sendEditWorkFlow(this.changeWorkFlowOptions).then(workflow => {
            this.status = JSON.stringify(workflow.res);
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: 'Stage Updated' });
          });

        }

        this.activityOptions = {
          user: this.userEmail,
          action: "Edit",
          file: "--"
        };

        this.newReleaseService.sendActivity(this.activityOptions).then(res => {
          this.activityResponce = res;
        });


        this.sendEditReleaseData();

        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Saved' });
        this.uploader.queue = [];
        this.display = false;

      } else {
        this.validateAllFormFields(this.releaseUpdateForm);
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Invalid', detail: '' });
      }
    }



  }

  constructor(private fb: FormBuilder,
    private newReleaseService: NewReleaseService,
    private homeService: HomeService,
    private mainService: MainService,
    private authService: AuthService,
    private router: Router,
    private confirmationService: ConfirmationService,
    public dialog: MatDialog,
    private _renderer2: Renderer2, @Inject(DOCUMENT) private _document) {

  }

  public uploader: FileUploader = new FileUploader({ url: URL });
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;


  public uploadData() {

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Uploaded', detail: item.file.name });

      this.isUploaded = true;
      this.isFileSelected = false;
      this.isNoteSelected = false;
    };

    this.uploader.onCompleteAll = () => {

      this.isUploaded = true;
      this.isFileSelected = false;
      this.isNoteSelected = false;
      setTimeout(() => {
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Don\'t Forget to hit the \'Save\' Button !!' });
      },
        1500);

    };

    this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
      this.msgs = [];
      this.msgs.push({ severity: 'Error', summary: 'Upload Failed' });
    };
  }



  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  stripHTML(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText;
  }

  sendEditReleaseData() {

    this.homeService.sendEditData(this.editOptions).then(res => {
      this.responce = res;

      if (this.responce.status == 'sent') {
        this.isSaved = true;

        this.sendEditEmail();



        setTimeout(() => {
          this.getReleaseData();
        },
          10);
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'Error', summary: this.responce });
      }

    });
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  confirmDiscard(r: Release) {
    if (r.owner == this.userName || r.uploaded_by == this.userName || r.qa == this.userName || this.is_Admin == '1') {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to discard this release?',
        header: 'Discard Confirmation',
        accept: () => {
          this.discardRelease(r);
        },
        reject: () => {
          this.msgs = [];
          this.msgs = [{ severity: 'info', summary: 'Request cancelled' }];
        }
      });
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Discard Release', detail: 'No Permission' });
    }
  }

  confirmReject(r: Release) {
    if (r.owner == this.userName || r.uploaded_by == this.userName || r.qa == this.userName || this.is_Admin == '1') {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to reject this release?',
        header: 'Reject Confirmation',
        accept: () => {
          this.rejectRelease(r);
        },
        reject: () => {
          this.msgs = [];
          this.msgs = [{ severity: 'info', summary: 'Request cancelled' }];
        }
      });
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Reject Release', detail: 'No Permission' });
    }
  }

  sendEditEmail() {
    this.newReleaseService.sendReleaseEmail(this.editEmailOptions).then(res => {
      this.activityResponce = res;
    });
  }



  ngOnInit() {
    this.getProjects();
    localStorage.removeItem('previousURL');

//     let s = this._renderer2.createElement('script');
//     s.type = `text/javascript`;
//     s.text = `
//         {
//           // window.$crisp=[];window.CRISP_WEBSITE_ID="ac723b1c-1ab7-47d5-bbb6-029139282955";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
//           window.$crisp=[];window.CRISP_WEBSITE_ID="36784d26-0d65-4227-afc4-5201622f7b5a";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
//           // code.tidio.co/a7lp9cqpk0rnuboxditkg7jijhibzgbv.js

//           //  ******* tawk chat *********

// // var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
// // (function(){
// // var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
// // s1.async=true;
// // s1.src='https://embed.tawk.to/5d1ae8ea22d70e36c2a3b01f/default';
// // s1.charset='UTF-8';
// // s1.setAttribute('crossorigin','*');
// // s0.parentNode.insertBefore(s1,s0);
// // })();

// // (function(w, d, s, u) {
// // 	w.RocketChat = function(c) { w.RocketChat._.push(c) }; w.RocketChat._ = []; w.RocketChat.url = u;
// // 	var h = d.getElementsByTagName(s)[0], j = d.createElement(s);
// // 	j.async = true; j.src = 'https://live-chat.directfn.net/packages/rocketchat_livechat/assets/rocketchat-livechat.min.js?_=201702160944';
// // 	h.parentNode.insertBefore(j, h);
// // })(window, document, 'script', 'https://live-chat.directfn.net/livechat');

//         }
//     `;

//     this._renderer2.appendChild(this._document.body, s);

    // release update 
    // this.releaseUpdateForm = this.fb.group({
    //   project: [{ value: '', disabled: true }, Validators.required],
    //   component: [{ value: '', disabled: true }, Validators.required],
    //   owner: ['', Validators.required],
    //   version: ['', Validators.required],
    //   description: ['', Validators.required],
    //   workflow: [''],
    //   comment: ['', Validators.compose([Validators.required, Validators.minLength(20), Validators.maxLength(100)])],
    //   qa: ['', Validators.required],
    //   emailList: ['']
    // });


    // this.releaseUpdateForm.get('workflow').valueChanges.subscribe(workflow => {
    //   if (workflow != undefined) {

    //     if (workflow.id - 1 > this.wid) {
    //       this.isComment = true;
    //     } else {
    //       this.isComment = false;
    //     }

    //   }

    // })
    
    // this.getReleaseData();
    this.isValidSession();

    
    this.search();

    

    this.getReleaseComponents();

    this.getWorkflow();
    
  }

  rowDblClick(event) {
    this.router.navigate(['/Release/' + event.data.id]);
  }

}
